import React from "react";
import { render } from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import { dangerColor, primaryColor, whiteColor } from "./assets/colors";
import { ThemeProvider } from "@emotion/react";
import { AppStateProvider } from "./contexts/AppStateContext";
import * as Sentry from "@sentry/react";
import { ToastProvider } from "contexts/ToastContext";
import { QueryClient, QueryClientProvider } from "react-query";

const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor[0],
      contrastText: whiteColor,
    },
    secondary: {
      main: dangerColor[1],
      contrastText: whiteColor,
    },
    disabled: {
      main: "#F8F8F8",
      contrastText: whiteColor,
    },
  },
});

// NODE_ENV is "production" for every `react-scripts build` and "development"
// for `npm start`, so Sentry is off locally. REACT_APP_NODE_ENV separates the
// staging deploy ("development") from the release deploy ("production").
// REACT_APP_VERSION is the release tag on production builds and the commit
// sha on staging (set by the workflows); locally it falls back to the
// package.json version via .env.production.
if (process.env.NODE_ENV === "production") {
  const environment = process.env.REACT_APP_NODE_ENV || "production";
  const version = (process.env.REACT_APP_VERSION || "").replace(/^v/, "");
  Sentry.init({
    dsn: "https://f3366f1b06f0491d8abe3973ef1827a4@o994889.ingest.us.sentry.io/4504333236174848",
    release: "easypartz-dashboard@" + version,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    // Errors are always sent; this only samples performance transactions.
    tracesSampleRate: environment === "production" ? 0.1 : 1.0,
  });
}

const queryClient = new QueryClient();

const container = document.getElementById("root");
render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <AppStateProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AppStateProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  container
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
